<script setup>
import Spinner from 'shared/components/Spinner.vue';

defineProps({
  data: {
    type: Array,
    default: () => [],
  },
  loading: {
    type: Boolean,
    default: false,
  },
  title: {
    type: String,
    default: 'Etiquetas Mais Usadas',
  },
});
</script>

<template>
  <div class="flex flex-col rounded-xl border border-n-weak bg-n-solid-2 p-4">
    <!-- Header -->
    <div class="mb-4">
      <h3 class="text-base font-semibold text-n-slate-12">{{ title }}</h3>
    </div>

    <!-- Loading State -->
    <div v-if="loading" class="flex items-center justify-center h-20">
      <Spinner size="small" />
    </div>

    <!-- Empty State -->
    <div
      v-else-if="data.length === 0"
      class="flex items-center justify-center h-20 text-n-slate-11"
    >
      <span class="text-sm">Nenhuma etiqueta encontrada</span>
    </div>

    <!-- Labels Cloud -->
    <div v-else class="flex flex-wrap gap-2">
      <div
        v-for="label in data"
        :key="label.id"
        class="flex items-center gap-1.5 px-2.5 py-1 rounded-full text-sm"
        :style="{
          backgroundColor: `${label.color}20`,
          color: label.color,
        }"
      >
        <span
          class="w-2 h-2 rounded-full"
          :style="{ backgroundColor: label.color }"
        />
        <span class="font-medium">{{ label.title }}</span>
        <span class="opacity-70">{{ label.count }}</span>
      </div>
    </div>
  </div>
</template>
